import React, { useState } from "react";

import { Modal } from "react-bootstrap";
import { ScoreCalculationNode, simplifyScoreExplanation } from "shared/src/scoreExplanationAnalysis";
import { SearchResultDebugInfo, SearchResultLtrDebugInfo } from "shared/src/types/ArticleCardProps";

type ScoreExplanationPanelProps = {
    node: ScoreCalculationNode;
};

type Props = {
    debugInfo: SearchResultDebugInfo | null | undefined;
    ltrDebugInfo: SearchResultLtrDebugInfo | undefined | null;
    isEmployee: boolean;
};

function ScoreExplanationPanel({ node }: ScoreExplanationPanelProps) {
    const niceDescription = node.niceDescription;
    const description = node.description;
    const className = node.match === false ? "no-match" : "";
    return (
        <div className={className}>
            {node.value}
            {node.value !== null && node.value !== undefined && " = "}
            {niceDescription}
            {description && !niceDescription && <pre>{description}</pre>}
            {node.details && (
                <ul>
                    {node.details.map((nodeDetail, i) => (
                        <li key={i}>
                            <ScoreExplanationPanel node={nodeDetail} />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

function _renderLTRDebugInfo(ltrDebugInfo: SearchResultLtrDebugInfo | undefined | null) {
    const features = ltrDebugInfo ? ltrDebugInfo.features : null;
    const score = ltrDebugInfo ? ltrDebugInfo.ltrScore : null;
    if (!features) return null;
    return (
        <div className={"sd-ltr-debug-info"}>
            <p>LTR model info</p>
            <p>
                <b>LTR Score: </b>
                {score ? score : null}
            </p>
            {Object.keys(features).map((key) => (
                <ul key={key}>
                    <b>{key}</b>
                    <p>{features[key]}</p>
                </ul>
            ))}
        </div>
    );
}

function _renderScoreDialog({ debugInfo, ltrDebugInfo }: Props, setShowScoreDialog: (ex: boolean) => void) {
    return (
        <Modal show onHide={() => setShowScoreDialog(false)} className="sd-score-explanation-modal">
            <Modal.Header closeButton>
                <Modal.Title>Score explanation</Modal.Title>
            </Modal.Header>
            <Modal.Body className="container-fluid">
                <ScoreExplanationPanel node={simplifyScoreExplanation(debugInfo?.explain as any)} />
                {_renderLTRDebugInfo(ltrDebugInfo)}
            </Modal.Body>
        </Modal>
    );
}

function SearchResultDebugInfoPanel({ debugInfo, ltrDebugInfo, isEmployee }: Props) {
    const [showScoreDialog, setShowScoreDialog] = useState(false);
    if (isEmployee && (debugInfo || ltrDebugInfo))
        return (
            <div className="sd-search-result-debug-info" style={{ order: 99 }}>
                <div style={{ fontSize: "70%", display: "inline-block" }}>
                    Score: {debugInfo?.score}{" "}
                    <a
                        style={{ fontSize: "70%" }}
                        onClick={() => setShowScoreDialog(true)}
                        className="test-search-result-debug-show">
                        (details)
                    </a>
                    <br />
                    Indexing time: {debugInfo?.indexingTime}
                    <br />
                    {showScoreDialog && _renderScoreDialog({ debugInfo, ltrDebugInfo, isEmployee }, setShowScoreDialog)}
                </div>
            </div>
        );
    else return null;
}

export default SearchResultDebugInfoPanel;
